import { useCallback, useState } from "react"
import _get from "lodash/get"
import _map from "lodash/map"
import _clone from "lodash/clone"
import _forEach from "lodash/forEach"
import _isEmpty from "lodash/isEmpty"

const LABEL_MAP = {
  DADOS: "Dados Móveis",
  SMS: "SMS/MMS",
  "VOZ MOVEL": "Voz Móvel",
  "VOZ FIXA": "Voz Fixa"
}

const CHART_COLORS = {
  DADOS: "#0087DC",
  SMS: "#FF9100",
  "VOZ MOVEL": "#00BE14",
  "VOZ FIXA": "#1EFFD2",
  default: "#00BEFF"
}

const DATA_LABEL = {
  DADOS: "megabytes",
  SMS: "mensagen(s)",
  "VOZ MOVEL": "minuto(s)",
  "VOZ FIXA": "minuto(s)",
  default: "consumo"
}

const convertedToMB = (value) => {
  const rawKb = parseFloat(value.replace(/\./g, "").replace(",", "."))
  const mb = rawKb / 1024

  return parseInt(mb)
}

const convertToMinutes = (value) => {
  const match = value.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/)

  const hours = parseInt(match[1] || "0", 10)
  const minutes = parseInt(match[2] || "0", 10)
  const seconds = parseInt(match[3] || "0", 10)

  const totalMinutes = hours * 60 + minutes + seconds / 60

  return Math.floor(totalMinutes)
}

const getChartData = (key, usageSpecifications) => {
  switch (key.toUpperCase()) {
    case "DADOS":
      return _map(usageSpecifications, (usage) =>
        convertedToMB(_get(usage, "description", ""))
      )
    case "SMS":
      return _map(usageSpecifications, (usage) =>
        parseInt(_get(usage, "description", ""))
      )

    case "VOZ MOVEL":
    case "VOZ FIXA":
      return _map(usageSpecifications, (usage) =>
        convertToMinutes(_get(usage, "description", ""))
      )

    default:
      return []
  }
}

const filterDataBySelectedMonths = (data, periods) => {
  if (_isEmpty(periods)) return data

  const filteredData = _clone(data)

  filteredData.months = []
  filteredData.data = []

  _forEach(data.months, (month, index) => {
    if (periods.includes(month)) {
      filteredData.months.push(month)
      filteredData.data.push(data.data[index])
    }
  })

  return filteredData
}

export const useChartData = (profileData, periods) => {
  const parsedData = _map(profileData, (item) => {
    const key = _get(item, "level1", "")
    const usage = _get(item, "usageSpecifications", [])
    return {
      key,
      label: _get(LABEL_MAP, key, key),
      data: getChartData(key, usage),
      color: _get(CHART_COLORS, key, CHART_COLORS.default),
      months: _map(usage, (spec) => _get(spec, "name", "")),
      dataLabel: _get(DATA_LABEL, key, key)
    }
  })

  const [currentData, setCurrentData] = useState(_get(parsedData, 0, {}))
  const currentChartData = filterDataBySelectedMonths(currentData, periods)
  const handleCurrentData = useCallback((data) => setCurrentData(data), [])

  return {
    parsedData,
    currentData,
    currentChartData,
    handleCurrentData
  }
}



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/hooks/useChartData.js